/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Task = {

	deleteArea (context, areaId, onSuccess, onError, options) {
		Api.delete(context,
			"/task/area"
			+ "?areaId=" + areaId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deletePriority (context, priorityId, onSuccess, onError, options) {
		Api.delete(context,
			"/task/priority"
			+ "?priorityId=" + priorityId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteTask (context, taskId, onSuccess, onError, options) {
		Api.delete(context,
			"/task/task"
			+ "?taskId=" + taskId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	deleteTaskAccreditationCountry (context, countryId, onSuccess, onError, options) {
		Api.delete(context,
			"/task/task-accreditation-country"
			+ "?countryId=" + countryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAreas (context, priorityId, onSuccess, onError, options) {
		Api.get(context,
			"/task/areas"
			+ "?priorityId=" + priorityId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCountriesToAdd (context, taskId, onSuccess, onError, options) {
		Api.get(context,
			"/task/countries-to-add"
			+ "?taskId=" + taskId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getCountryTasks (context, contestId, countryId, onSuccess, onError, options) {
		Api.get(context,
			"/task/country-tasks"
			+ "?contestId=" + contestId
			+ "&countryId=" + countryId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getPriorities (context, taskAccreditationCountryId, onSuccess, onError, options) {
		Api.get(context,
			"/task/priorities"
			+ "?taskAccreditationCountryId=" + taskAccreditationCountryId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTaskAccreditationCountries (context, taskId, onSuccess, onError, options) {
		Api.get(context,
			"/task/task-accreditation-countries"
			+ "?taskId=" + taskId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTasks (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/task/tasks"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTasksTree (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/task/tasks-tree"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTasksValidate (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/task/tasks-validate"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAreaHigherInView (context, areaId, onSuccess, onError, options) {
		Api.post(context,
			"/task/area-higher-in-view"
			+ "?areaId=" + areaId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postAreaLowerInView (context, areaId, onSuccess, onError, options) {
		Api.post(context,
			"/task/area-lower-in-view"
			+ "?areaId=" + areaId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postChangePhrase (context, contestId, textChangerDTO, onSuccess, onError, options) {
		Api.post(context,
			"/task/change-phrase"
			+ "?contestId=" + contestId
			, textChangerDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCopyCountryPriorities (context, countryId, countryToCopyId, onSuccess, onError, options) {
		Api.post(context,
			"/task/copy-country-priorities"
			+ "?countryId=" + countryId
			+ "&countryToCopyId=" + countryToCopyId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCopyCountryPriority (context, countryId, priorityToCopyId, onSuccess, onError, options) {
		Api.post(context,
			"/task/copy-country-priority"
			+ "?countryId=" + countryId
			+ "&priorityToCopyId=" + priorityToCopyId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCopyPriorityArea (context, priorityId, areaToCopyId, onSuccess, onError, options) {
		Api.post(context,
			"/task/copy-priority-area"
			+ "?priorityId=" + priorityId
			+ "&areaToCopyId=" + areaToCopyId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCopyPriorityAreas (context, priorityId, priorityToCopyId, onSuccess, onError, options) {
		Api.post(context,
			"/task/copy-priority-areas"
			+ "?priorityId=" + priorityId
			+ "&priorityToCopyId=" + priorityToCopyId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCopyTaskCountries (context, taskId, countryToCopyId, countryIds, onSuccess, onError, options) {
		Api.post(context,
			"/task/copy-task-countries"
			+ "?taskId=" + taskId
			+ "&countryToCopyId=" + countryToCopyId
			+ "&countryIds=" + countryIds
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCountryHigherInView (context, countryId, onSuccess, onError, options) {
		Api.post(context,
			"/task/country-higher-in-view"
			+ "?countryId=" + countryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCountryLowerInView (context, countryId, onSuccess, onError, options) {
		Api.post(context,
			"/task/country-lower-in-view"
			+ "?countryId=" + countryId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postImportFromContest (context, contestId, anotherContestId, onSuccess, onError, options) {
		Api.post(context,
			"/task/import-from-contest"
			+ "?contestId=" + contestId
			+ "&anotherContestId=" + anotherContestId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postPriorityHigherInView (context, priorityId, onSuccess, onError, options) {
		Api.post(context,
			"/task/priority-higher-in-view"
			+ "?priorityId=" + priorityId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postPriorityLowerInView (context, priorityId, onSuccess, onError, options) {
		Api.post(context,
			"/task/priority-lower-in-view"
			+ "?priorityId=" + priorityId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRenameArea (context, areaId, newName, onSuccess, onError, options) {
		Api.post(context,
			"/task/rename-area"
			+ "?areaId=" + areaId
			+ "&newName=" + newName
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRenamePriority (context, priorityId, newName, onSuccess, onError, options) {
		Api.post(context,
			"/task/rename-priority"
			+ "?priorityId=" + priorityId
			+ "&newName=" + newName
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postRenameTask (context, taskId, newName, onSuccess, onError, options) {
		Api.post(context,
			"/task/rename-task"
			+ "?taskId=" + taskId
			+ "&newName=" + newName
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTaskDuplicate (context, taskId, onSuccess, onError, options) {
		Api.post(context,
			"/task/task-duplicate"
			+ "?taskId=" + taskId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTaskHigherInView (context, taskId, onSuccess, onError, options) {
		Api.post(context,
			"/task/task-higher-in-view"
			+ "?taskId=" + taskId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTaskLowerInView (context, taskId, onSuccess, onError, options) {
		Api.post(context,
			"/task/task-lower-in-view"
			+ "?taskId=" + taskId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putArea (context, priorityId, name, onSuccess, onError, options) {
		Api.put(context,
			"/task/area"
			+ "?priorityId=" + priorityId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putPriority (context, countryId, name, onSuccess, onError, options) {
		Api.put(context,
			"/task/priority"
			+ "?countryId=" + countryId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putTask (context, contestId, name, onSuccess, onError, options) {
		Api.put(context,
			"/task/task"
			+ "?contestId=" + contestId
			+ "&name=" + name
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putTaskAccreditationCountries (context, taskId, countryIds, onSuccess, onError, options) {
		Api.put(context,
			"/task/task-accreditation-countries"
			+ "?taskId=" + taskId
			+ "&countryIds=" + countryIds
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
